import script from "./ClickByUserAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./ClickByUserAgent.vue?vue&type=script&setup=true&lang=js"

import "./ClickByUserAgent.vue?vue&type=style&index=0&id=5a58f633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a58f633"]])

export default __exports__